
    <div *ngIf="!!pageTitle" [innerHtml]="pageTitle | safeHtml"></div>

<app-base-pay-customs serviceTypeId="8" [image]="image" numberInputFieldName="{{'pay_customs.invoice.invoice_number' | translate}}" inputFieldNamePlaceholder="{{'pay_customs.invoice.enter_invoice_number' | translate}}"></app-base-pay-customs>
<div *ngIf="!!pageModules" [innerHtml]="pageModules | safeHtml"></div>